import axios from "../axios";

// 上移
export const moveUp = (data) => {
  return axios({
    url: '/commonPage/moveUp',
    method: 'post',
    data
  })
};

// 下移
export const moveDown = (data) => {
  return axios({
    url: '/commonPage/moveDown',
    method: 'post',
    data
  })
};

// 导出
export const exportExcel = (data) => {
  return axios({
    url: '/commonPage/exportExcel',
    method: 'post',
    responseType: 'blob',
    data
  })
};




// WEBPACK FOOTER //
// ./src/http/moudules/commonPage.js